const trimStringNumber = (str, number = 30) => {
  const newStr = str.substring(0, number).trim()

  if (str.length > number) return `${ newStr }...`

  return newStr
}

export default trimStringNumber